import { useParams } from "react-router-dom";
import ActivityFlow from "./ActivityFlow";
import { ReactFlowProvider } from "@xyflow/react";

const ActivityFlowRenderer = ({ activityData, setActivityData, allJobs }) => {
  const { smId, activityId } = useParams();

  return (
    <ReactFlowProvider>
      <ActivityFlow
        activityData={activityData}
        setActivityData={setActivityData}
        allJobs={allJobs}
        smId={smId}
        activityId={activityId}
      />
    </ReactFlowProvider>
  );
};

export default ActivityFlowRenderer;
